import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

import { offDayTypesEnum } from 'modules/project_management/lib/constants'

import { ICurrentWeekHeaderInfo } from './_Header'

export const getHalfDayLabelTranslation = (halfDay: string) => {
  switch (halfDay) {
    case 'beggining_of_day':
      return i18n.t('clock_in.off_day_popover.day_type.beginning_of_day')
    case 'end_of_day':
      return i18n.t('clock_in.off_day_popover.day_type.end_of_day')
  }
}

export const createDateRange = (
  startOn: string,
  finishOn: string | null | undefined,
  offDayName: string | null | undefined,
  halfDay: string | null | undefined,
  __typename: string | undefined
) => {
  const start = moment(startOn)
  const end = moment(finishOn)
  const range = []

  const current = start.clone()
  while (current.isSameOrBefore(end)) {
    range.push({
      date: current.format('YYYY-MM-DD'),
      offDayName,
      halfDay,
      __typename,
    })
    current.add(1, 'days')
  }

  return range
}

export const isOffDay = (index: number, currentWeekHeaderInfo: ICurrentWeekHeaderInfo[]) => {
  return currentWeekHeaderInfo[index]?.offDayType !== offDayTypesEnum.withoutOffDay
}
